<template>
    <div>
        <div class="main-wrapper">
            <layout-header @changedLanguage="changedLanguage"></layout-header>
            <layout-navbar></layout-navbar>
           <!-- Page Wrapper -->
           <div class="page-wrapper">

            <!-- Page Content -->
            <div class="content container-fluid">

                <div class="crms-title row bg-white">
                    <div class="col  p-0">
                        <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> {{ $t('menu.action_plan') }} </h3>
                    </div>
                    <div class="col p-0 text-right">
                        <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                            <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                            <li class="breadcrumb-item active">{{ $t('menu.action_plan') }}</li>
                        </ul>
                    </div>
                </div>

                <!-- Page Header -->
                <div class="page-header pt-3 mb-0 ">
                    <div class="row">
                        <div class="col">
                          <div class="dropdown">
                            <a class="dropdown-toggle recently-viewed" id="statusDropdown" href="#" role="button" data-toggle="dropdown"
                               aria-expanded="false" data-bs-auto-close="outside">
                              {{ selectedFiltersLabel }}
                            </a>
                            <div class="dropdown-menu">
                              <a class="dropdown-item" href="#" @click.prevent="toggleFilter('all')">
                                <input type="checkbox" :checked="selectedFilters.includes('all')" class="mr-2" readonly tabindex="-1" @click.prevent>
                                {{ $t('all') }} {{ $t('entries') }}
                              </a>
                              <a class="dropdown-item" href="#" @click.prevent="toggleFilter('Offen')">
                                <input type="checkbox" :checked="selectedFilters.includes('Offen')" class="mr-2" readonly tabindex="-1" @click.prevent>
                                {{ $t('all') }} {{ $t('open_tasks') }}
                              </a>
                              <a class="dropdown-item" href="#" @click.prevent="toggleFilter('In Bearbeitung')">
                                <input type="checkbox" :checked="selectedFilters.includes('In Bearbeitung')" class="mr-2" readonly tabindex="-1" @click.prevent>
                                {{ $t('all') }} {{ $t('processing_tasks') }}
                              </a>
                              <a class="dropdown-item" href="#" @click.prevent="toggleFilter('Abgeschlossen')">
                                <input type="checkbox" :checked="selectedFilters.includes('Abgeschlossen')" class="mr-2" readonly tabindex="-1" @click.prevent>
                                {{ $t('all') }} {{ $t('completed_tasks') }}
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col text-right">
                            <ul class="list-inline-item pl-0">
                              <li class="list-inline-item">
                                <DisplayColumnsComponent :table="table" :columns="columns" v-if="table"></DisplayColumnsComponent>
                              </li>
                              <li class="list-inline-item">
                                  <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" id="add-task" @click.prevent="addTodo">{{ $t('new_task') }}</button>
                              </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /Page Header -->

              <!-- Content Starts -->
              <DataTableDSMS
                ref="dataTableDSMS"
                title="Maßnahmenplan"
                fileName="Maßnahmenplan"
                modelName="task"
                deleteURL="todos/v1/delete_task/"
                :extraActions="extraActions"
                :editorPatchURL="editorPatchURL"
                :columns="columns"
                :objects="task_list"
                :exportColumns="[0, 1]"
                :exportHidden="true"
                :editorCallback="true"
                :initCallbackFunctions="initCallbackFunctions"
                @tableCreated="setTable"
                @editorCreated="setEditor"
                @showObject="showTask"
                @callDrawback="drawCallbackFunctions"
                @editorUpdated="updateTodo"
                v-if="promiseFinished"
              ></DataTableDSMS>

              <FingerPrintSpinner v-show="!promiseFinished" color="#9b3136" :size="300" :container-padding="100" />
              <!-- /Content End -->

            </div>
            <!-- /Page Content -->

        </div>
        <!-- /Page Wrapper -->
        </diV>

		<!--modal section starts here-->
    <task :currentTodo="currentTodo" :origin="currentTodo.model" :editTodoProps="editTodo" @editTodoChanged="changeEditTodo" @todoUpdated="updateTodo" type="DS">
      <template v-slot:works>
        <Work
          :current-todo="currentTodo"
          @workUpdated="patchTodoWorks"
        ></Work>
      </template>
      <template v-slot:steps>
        <Steps
          :totalSteps="currentTodo.steps"
          :taskID="currentTodo.id"
          :editTodo="editTodo"
          @stepsUpdated="setSteps"
        ></Steps>
      </template>
    </task>

      <GAP :componentID="objectModalName.question" :currentGap="objectVariables.question"></GAP>
      <VT :currentVT="objectVariables.vt">
        <template v-slot:fileUpload><file-upload :commentObject="objectVariables.vt" modelName="vt" modelVerboseName="VT"></file-upload></template>
        <template v-slot:comments><comments :commentObject="objectVariables.vt" modelName="vt" modelVerboseName="VT"></comments></template>
      </VT>
    </div>
</template>
<script>
  import {service, baseURL} from '@/utils/request.js';
  import {mapState, mapMutations} from 'vuex';
  import Modal from '@/components/component/Modal'
  import {deepCopy, initSelect2, originText} from '@/utils/index.js';
  import {PRIORITY, newTodo, STATUS, getURL, objectModalName, newVT} from '@/utils/enums.js';
  import datePicker from 'vue-bootstrap-datetimepicker';
  import DataTableDSMS from "@/components/component/DataTableDSMS";
  import fileUpload from "@/components/component/FileUploadComponent.vue";
  import Steps from "@/components/component/Steps.vue";
  import Work from "@/components/component/WorksComponent.vue";
  import task from "@/components/component/TodoComponent.vue";
  import GAP from "@/components/component/GapComponent.vue";
  import VT from "@/components/component/VTComponent.vue";
  import comments from "@/components/component/CommentComponent.vue";
  import DisplayColumnsComponent from "@/components/component/DisplayColumnsComponent.vue";
  import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";
	export default {
    components: {
      FingerPrintSpinner,
      DisplayColumnsComponent, fileUpload, comments, task, Steps, Work, Modal, DataTableDSMS, GAP, VT, datePicker},
    props: {
      questionID: {
        default: null,
        type: Number,
      },
      questionDescription: {
        default: '',
        type: String,
      },
      model: {
        default: 'question',
        type: String,
      }
    },
    data() {
      return {
        objectModalName: objectModalName,
        surveyJSON: '',
        task_list: [],
        stepTitle: '',
        current_question: {},
        current_survey: '',
        datetimeOptions: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
        },
        currentObject: {},
        editTodo: false,
        promiseFinished: false,
        currentGap: {
          topic: {
            name: '',
            description: '',
            new_intern_number: '',
          },
          last_answer: {
            question_answer: '',
            modified_on: '',
            modified_by: '',
          }
        },
        currentVT: {},
        objectVariables: {
          question: {
            topic: {
              name: '',
              description: '',
              new_intern_number: '',
            },
            last_answer: {
              question_answer: '',
              modified_on: '',
              modified_by: '',
            }
          },
          vt: newVT
        },
        question_list: [],
        status: STATUS,
        priority: PRIORITY,
        help_text: '',
        table: null,
        editor: null,
        currentTodo: newTodo,
        editorPatchURL: '/todos/v1/patch_task/',
        selectedFilters: ['all'],
      }
    },
    created() {
      this.getTasks()
    },
    computed: {
      ...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id}),
      dataReady() {
        return this.task_list.length > 0
      },
      columns() {
        return [
        {
          label: 'Nr.#',
          name: 'sequence',
          enableEditor: false,
          definition: {data: "sequence", width: '50px', className: 'dkl-vt-sequence reorder'},
        },
        {
          label: this.$t('added'),
          name: 'added',
          enableEditor: false,
          definition: { data: "added", width: "5%", render: (data) => typeof data === 'string' ? data.substring(0, 10) : ''},
        },
        {
          label: this.$t('origin'),
          name: 'question_category',
          enableEditor: false,
          definition: { data: "question_category", width: "8%", render: (data, type, row) => {
              const content = !(data) ? originText(row.origin) : `${originText(row.origin) ? originText(row.origin) : 'K.A.'} - ${data}`
              if (row.recurring) return `<span>${content}</span><span  class="dkl-green ml-1"><i class="fa fa-refresh" aria-hidden="true"></i></span>`
              return `<span>${content}</span>`
            }},
        },
        {
          label: this.$t('section'),
          name: 'target',
          enableEditor: false,
          definition: { data: null, width: "8%", render: (data) => `<a href="#" class="related-gap" data-question-id="${data.question}">${data.question_topic}</a>` },
        },
        {
          label: this.$t('questionnaire'),
          name: 'question_description',
          enableEditor: false,
          definition: { data: 'question_description', visible: false, width: "100px" },
        },
        {
          label: this.$t('description'),
          name: 'description',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "description", width: "20%", render: (data, type, row) => `<span>${data}</span>${row.crm_works && row.crm_works.length > 0 ?
              '<span class="badge-todo badge badge-pill">' + row.crm_works.length + '</span>' : ''}` },
        },
        {
          label: this.$t('deadline'),
          name: 'due_date',
          type: 'datetime',
          def: () => new Date(),
          enableEditor: true,
          definition: { data: "due_date", width: "5%"},
        },
        {
          label: this.$t('remarks'),
          name: 'remarks',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "remarks", width: "14%"},
        },
        {
          label: this.$t('steps'),
          name: 'steps',
          enableEditor: false,
          definition: { data: "steps", render: (data)=>{
              let returnHtml = ''
              data.forEach((step) => {
                returnHtml += `<span class="dkl-span-new-line keep-new-line">${step.name} - ${step.status}</span><span>-------------------------------------</span>`
              })
              return returnHtml
            }, width: "25%"},
        },
        {
          label: this.$t('actual_status'),
          name: 'status',
          type: 'select2',
          options: STATUS,
          filterStyle: 'dropdown',
          enableEditor: true,
          definition: { data: "status", render: (data) => `<span class="dkl-bg-${data.toLowerCase().replace(' ', '')}">${data}</span>`, width: "5%", editField: ['status']},
        },
        {
          label: this.$t('responsible_person'),
          name: 'assigned_to_char',
          type: 'text',
          enableEditor: true,
          definition: { data: "assigned_to_char", width: "5%" },
        },
        {
          label: 'Prio',
          name: 'priority',
          type: 'select',
          options: PRIORITY,
          enableEditor: true,
          definition: { data: "priority", render: (data) => `<span class="dkl-bg-${data.toLowerCase().replace(' ', '')}">${data}</span>`, width: "5%"},
        },
      ]},
      selectedFiltersLabel() {
        if (this.selectedFilters.includes('all')) return 'Alle'
        return this.selectedFilters.join(', ');
      },
    },
    mounted() {
      initSelect2()
      },
    methods: {
      ...mapMutations({setEdit: "SET_EDIT"}),
      async changedLanguage() {
        this.$nextTick(async () => {
          const selectDom = $('.dkl-status-select');
          if (selectDom.length > 0) {
            selectDom.off('change');
            selectDom.empty();
          }
          if (this.table) this.table.destroy();
          await this.$refs.dataTableDSMS.initTable();
        });
      },
      setTable(table) {
        this.table = table
      },
      setEditor(editor) {
        this.editor = editor
      },
      changeEditTodo(value) {
        this.editTodo = value
      },
      setSteps(steps) {
        this.currentTodo.steps = steps
      },
      showTask(objectID) {
        this.currentTodo = this.task_list.filter(item => item.id == objectID)[0]
        $('#add_massnahme').modal('show')
      },
      showTodos(e, targets) {
        // e.preventDefault()
        // if (target === 'open') this.table.clear().rows.add(this.task_list.filter((task) => task.status === 'Offen')).draw()
        // if (target === 'processing') this.table.clear().rows.add(this.task_list.filter((task) => task.status === 'In Bearbeitung')).draw()
        // if (target === 'closed') this.table.clear().rows.add(this.task_list.filter((task) => task.status === 'Abgeschlossen')).draw()
        $('.dkl-status-select').val('all').trigger('change')
        if (targets.includes('all')) this.table.clear().rows.add(this.task_list).draw()
        else this.table.clear().rows.add(this.task_list.filter((task) => targets.includes(task.status))).draw()
      },
      toggleFilter(filter) {
        if (filter === 'all') {
          this.selectedFilters = ['all'];
        } else {
          // Remove 'all' when a specific filter is selected
          this.selectedFilters = this.selectedFilters.filter(f => f !== 'all');
          const idx = this.selectedFilters.indexOf(filter);
          if (idx === -1) {
            this.selectedFilters.push(filter);
          } else {
            this.selectedFilters.splice(idx, 1);
          }
          // If nothing selected, fall back to 'all'
          if (this.selectedFilters.length === 0) {
            this.selectedFilters = ['all'];
          }
        }
        this.showTodos(null, this.selectedFilters);
      },
      extraActions(data) {
        return `<a class="dropdown-item related-object" href="#" data-object-id="${data.question ? data.question : data.object_id}" data-content-type="${data.content_type_name}">Herkunft Eintrag</a>`
      },
      initCallbackFunctions(api) {
        if ($('.dkl-status-select').length > 0 && this.task_list.length > 0) {
          $('.dkl-status-select').val('Offen').trigger('change')
        }
        // const columnId = this.columns.findIndex(column => column.name === 'state')
        // if (columnId === -1) return
        // const el = $(`.table-responsive .filter${columnId} .form-control`)
        // if (el.length) {
        //   if (el[0].nodeName === 'INPUT') {
        //     const select = $('<select class="form-control dkl-status-select" style="height: 30px !important;"></select>')
        //     select.append(new Option('-----', 'all'))
        //     api.cells('', columnId + 2)
        //       .render('display')
        //       .unique()
        //       .each(function (d, j) {
        //         let strOption = d.replace(/<\/?[^>]+(>|$)/g, "")
        //         select.append(new Option(strOption, strOption));
        //       });
        //     select.on('change', function () {
        //       let selectedValue = $(this).val()
        //       let val = DataTable.util.escapeRegex(selectedValue);
        //       api.column(columnId + 2)
        //         .search(val !== 'all' ? selectedValue : '', val !== 'all', val === 'all')
        //         .draw();
        //     });
        //     el.parent().empty().append(select)
        //     // console.log(select)
        //     // console.log($('.dkl-status-select'))
        //     // select.find('option[value="offen"]').prop('selected', true)
        //     // select.val('offen').trigger('change')
        //     return
        //   }
        //   // if (el[0].nodeName === 'SELECT') {
        //   //   console.log(el)
        //   //   const selValue = el.val()
        //   //   el.trigger('change')
        //   // }
        // }
      },
      drawCallbackFunctions() {
        const that = this
        $('.related-object').off('click').on('click', function(e) {
          e.preventDefault()
          const objectId = $(e.target).data('object-id');
          const contentType = $(e.target).data('content-type');
          if (!objectId) that.$vToastify.info('Maßnahme ist nicht mit anderem Eintrag verbunden!')
          if (Object.hasOwn(getURL, contentType)) {
            service.request({
              url: getURL[contentType](objectId),
              method: 'GET',
              responseType: 'json'
            }).then(function(res) {
              that.objectVariables[contentType] = res.data;
              $('#' + that.objectModalName[contentType]).modal('show');
            })
          } else {
            that.$vToastify.error('Herkunft Eintrag existiert nicht!')
          }
        })
        $('.related-gap').off('click').on('click', function(e) {
          e.preventDefault()
          const questionId = $(this).data('question-id');
          service.request({
            url: `todos/v1/get_gap/${questionId}/`,
            method: 'GET',
            responseType: 'json'
          }).then(function(res) {
            that.objectVariables.question = res.data;
            $('#' + objectModalName.question).modal('show');
          })
        })
      },
      addTodo() {
        this.currentTodo = deepCopy(newTodo);
        this.setEdit(true);
        $('#add_massnahme').modal('show');
      },
      updateTodo(todoObject) {
        const todoIndex = this.task_list.findIndex(task => task.id === todoObject.id)
        if (todoIndex === -1) {
          this.task_list = this.task_list.map(item => {
            item.sequence = item.sequence + 1
            return item
          })
          this.task_list.push(todoObject)
        } else {
          this.task_list[todoIndex] = todoObject
        }
        $('.datatable').DataTable().clear().rows.add(this.task_list).draw()
        this.$vToastify.success('Maßnahme ist erfolgreich gespeichert!')
        $('#add_massnahme').modal('hide')
      },
      async getTasks() {
        service.request({
          url: this.questionID === null ? `todos/v1/get_tasks/${this.accountid}/` : `todos/v1/get_tasks_by_model/${this.questionID}/?model=${this.model}`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.task_list = response.data;
          this.promiseFinished = true
        }).catch(function(err) {
          console.log(err)
        })
      },
      async patchTodoWorks(patchTodo) {
        const status = this.currentTodo.status;
        service.request({
          url: `todos/v1/patch_task/${patchTodo.id}/`,
          method: 'PUT',
          responseType: 'json',
          data: {
            id: patchTodo.id,
            crm_works: patchTodo.crm_works,
          }
        }).then((response) => {
          this.currentTodo = response.data;
          this.currentTodo.status = status;
          const todoIndex = this.task_list.findIndex(task => task.id === this.currentTodo.id)
          this.task_list[todoIndex] = this.currentTodo
          $('.datatable').DataTable().clear().rows.add(this.task_list).draw()
        }).catch(function(err) {
          console.log(err)
        })
      },
    }
	}
</script>
<style scoped>
  .dkl-title-h4 {
    background-color: #f3f1f1;
    align-items: center;
  }
  .strikethrough {
    text-decoration: line-through;
  }
  /* modal backdrop fix */
  .modal:nth-of-type(even) {
    z-index: 1050 !important;
  }
  .modal:nth-of-type(odd) {
    z-index: 1052 !important;
  }
  /*.modal-backdrop.show:nth-of-type(even) {*/
    /*z-index: 1051 !important;*/
  /*}*/
  .dkl-bg-offen, .dkl-bg-prioa {
    color: #ff0000;
  }
  .dkl-bg-abgeschlossen, .dkl-bg-prioc {
    color: #009900;
  }
  .dkl-bg-priob {
    color: orange;
  }
  .dkl-span-new-line {
    display: block;
  }
  .badge-todo {
    top: -5px;
    border-radius: 6rem;
    font-size: 75%;
    font-weight: 700;
    background-color: orange;
  }
</style>
